import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const fmtDate = (d) => { if (!d) return ''; return new Date(d).toLocaleDateString('da-DK'); };

export default function Vouchers() {
  const { apiFetch } = useAuth();
  const [vouchers, setVouchers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch('/api/vouchers').then(setVouchers).catch(err => setError(err.message));
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>Bilag</h1>
        <Link to="/app/bilag/ny" className="btn btn-primary">+ Nyt bilag</Link>
      </div>

      {error && <div className="alert alert-error" style={{marginBottom: '1rem'}}>{error}</div>}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Bilag nr.</th>
              <th>Dato</th>
              <th>Beskrivelse</th>
              <th>Status</th>
              <th>Oprettet af</th>
            </tr>
          </thead>
          <tbody>
            {vouchers.length === 0 ? (
              <tr><td colSpan="5" className="text-center">
                <div className="empty-state">
                  <p>Ingen bilag endnu</p>
                  <Link to="/app/bilag/ny" className="btn btn-primary">Opret dit første bilag</Link>
                </div>
              </td></tr>
            ) : vouchers.map(v => (
              <tr key={v.id} style={v.is_reversed ? {opacity: 0.6} : undefined}>
                <td><Link to={`/app/bilag/${v.id}`}>{v.voucher_number}</Link></td>
                <td>{fmtDate(v.date)}</td>
                <td>{v.description}</td>
                <td>
                  {v.is_reversed ? <span className="badge badge-inactive">Tilbageført</span> :
                   v.reverses_voucher_id ? <span className="badge" style={{background: '#fef3c7', color: '#92400e'}}>Modbogføring</span> :
                   <span className="badge badge-active">Aktiv</span>}
                </td>
                <td>{v.created_by_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
